/* Saint Ferro — Stoff-Lupe auf der Produktseite.
   Runde Lupe folgt dem Zeiger und zeigt den Ausschnitt vergroessert.
   Bindet sich per Selektor an das Hauptbild - kein Eingriff in main-product.liquid. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ZOOM = 2.5;
  var HOLD_MS = 250;

  function bigSrc(img) {
    var s = img.currentSrc || img.src || '';
    if (!s) return '';
    // Shopify-CDN: Breite hochdrehen. Die Produktbilder liegen mit 3900 px vor.
    if (s.indexOf('cdn.shopify.com') !== -1 || s.indexOf('/cdn/shop/') !== -1) {
      s = s.replace(new RegExp('([?&])width=[0-9]+'), '$1width=2400');
      if (s.indexOf('width=') === -1) s += (s.indexOf('?') === -1 ? '?' : '&') + 'width=2400';
    }
    return s;
  }

  function pickImages() {
    var sel = '.product__media img, .product-media img, [class*="product__media"] img';
    var list = Array.prototype.slice.call(document.querySelectorAll(sel));
    return list.filter(function (im) {
      var r = im.getBoundingClientRect();
      return r.width > 180 && r.height > 180;
    });
  }

  var loupe = document.createElement('div');
  loupe.className = 'sf-loupe';
  loupe.setAttribute('aria-hidden', 'true');
  document.body.appendChild(loupe);

  var active = null, holdTimer = null, touching = false, bound = [];

  function place(img, cx, cy) {
    var r = img.getBoundingClientRect();
    var x = (cx - r.left) / r.width;
    var y = (cy - r.top) / r.height;
    if (x < 0 || x > 1 || y < 0 || y > 1) { hide(); return; }
    var bw = r.width * ZOOM, bh = r.height * ZOOM;
    loupe.style.backgroundSize = bw + 'px ' + bh + 'px';
    var size = loupe.offsetWidth || 220;
    loupe.style.backgroundPosition = (-(x * bw) + size / 2) + 'px ' + (-(y * bh) + size / 2) + 'px';
    loupe.style.left = cx + 'px';
    loupe.style.top = cy + 'px';
  }

  function show(img, cx, cy) {
    var src = bigSrc(img);
    if (!src) return;
    active = img;
    loupe.style.backgroundImage = 'url("' + src + '")';
    place(img, cx, cy);
    loupe.classList.add('is-on');
  }
  function hide() {
    active = null;
    loupe.classList.remove('is-on');
  }

  function bind(img) {
    if (bound.indexOf(img) !== -1) return;
    bound.push(img);

    img.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      show(img, e.clientX, e.clientY);
    });
    img.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (active === img) place(img, e.clientX, e.clientY); else show(img, e.clientX, e.clientY);
    }, { passive: true });
    img.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      hide();
    });

    // Touch: erst nach kurzem Halten, damit Wischen weiterhin scrollt
    img.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; if (!t) return;
      // Sauberer Start: ein evtl. von der Maus offener Zustand darf hier nicht
      // hineinlecken (Touch-Laptops), sonst greift der Wisch-Abbruch nicht.
      hide();
      touching = true;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () {
        if (touching) show(img, t.clientX, t.clientY);
      }, HOLD_MS);
    }, { passive: true });

    img.addEventListener('touchmove', function (e) {
      var t = e.touches[0]; if (!t) return;
      if (active === img) {
        // Lupe ist offen -> jetzt darf das Scrollen unterdrueckt werden
        if (e.cancelable) e.preventDefault();
        place(img, t.clientX, t.clientY);
      } else {
        // noch nicht offen -> es ist ein Wisch, also Lupe abbrechen und scrollen lassen
        clearTimeout(holdTimer);
      }
    }, { passive: false });

    var stop = function () { touching = false; clearTimeout(holdTimer); hide(); };
    img.addEventListener('touchend', stop, { passive: true });
    img.addEventListener('touchcancel', stop, { passive: true });
  }

  // Bilder sind bei defer oft noch nicht ausgemessen (Lazy Loading, langsame
  // Verbindung). Deshalb mehrfach nachfassen statt einmal aufzugeben.
  var tries = 0;
  function scan() {
    pickImages().forEach(bind);
    tries++;
    if (bound.length === 0 && tries < 20) setTimeout(scan, 300);
  }
  scan();
  window.addEventListener('load', scan);

  window.addEventListener('scroll', hide, { passive: true });
})();